import {
    Box,
    Spinner,
    Step,
    StepDescription,
    StepIcon,
    StepIndicator,
    StepNumber,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    useBreakpointValue,
} from '@chakra-ui/react'
import { useContext, useEffect, useState } from "react"
import { StatusContext, IContextStatus } from '../Context/StatusContext';
import { X } from 'lucide-react';


const stepsCreation = [
    { title: 'Clonagem', description: 'Baixar o código' },
    { title: 'Compilação', description: 'Compilar o código' },
    { title: 'Publicação', description: 'Criar dependências' },
    { title: 'Finalização', description: 'Ajustes finais' },
]

const stepsDelete = [
    { title: 'Desligando', description: 'Removendo app do IIS' },
    { title: 'Apagando', description: 'Excluindo dependências' },
    { title: 'Removendo LHIG', description: 'Apagando LHIG' },
]

interface StepperBarProps {
    id: number
    error: string
}

interface StepsProps {
    title: string
    description: string
}

type Orientation = 'vertical' | 'horizontal';

export const StepperBar = ({ id, error }: StepperBarProps) => {
    const { contextStatus } = useContext(StatusContext);
    const [steps, setSteps] = useState<StepsProps[]>(stepsCreation);
    const [activeStep, setActiveStep] = useState(0);

    const orientation = useBreakpointValue<Orientation>({ base: 'vertical', md: 'horizontal' });
    const bgColorError = error != "" ? '#ef4444!important' : 'default'
    const borderColorError = error != "" ? '#ef4444!important' : 'transparent!important'
    const bgColor = steps.length == 3 ? 'orange.500!important' : 'default'
    const sepBgColor = steps.length == 3 ? '#f97316' : 'default'

    useEffect(() => {
        const status = contextStatus.find((c: IContextStatus) => c.id === id)?.status || 0;
        setSteps(status <= 4 ? stepsCreation : stepsDelete)
        if (status > 4)
            setActiveStep((error == "") ? status - 5 : status - 6);
        else
            setActiveStep((error == "") ? status : status - 1);
    }, [error, contextStatus, id]);

    return (
        <Stepper size='md' index={activeStep} orientation={orientation} className='h-full'>
            {steps.map((step, index) => (
                <Step key={index}>
                    <StepIndicator borderColor={index === activeStep ? borderColorError : ''} background={index === activeStep ? bgColorError : bgColor}>
                        <StepStatus
                            complete={<StepIcon />}
                            incomplete={<StepNumber />}
                            active={<ActiveIcon error={error} />}
                        />
                    </StepIndicator>

                    <Box flexShrink='0'>
                        <StepTitle className='text-primary'>{step.title}</StepTitle>
                        <StepDescription>{step.description}</StepDescription>
                    </Box>

                    <StepSeparator style={{ background: sepBgColor, height: '2px' }} />
                </Step>
            ))}
        </Stepper>
    )
}

interface ActiveIconProps {
    error: string
}

const ActiveIcon = ({ error }: ActiveIconProps) => {
    if (error === "")
        return <Spinner
            speed='2s'
            emptyColor='gray.200'
            color='blue.500'
            size='md'
        />
    return <X className='text-white' />
}